import { render, staticRenderFns } from "./PhonolEnvDetails.vue?vue&type=template&id=2aad518e&scoped=true&"
import script from "./PhonolEnvDetails.vue?vue&type=script&lang=js&"
export * from "./PhonolEnvDetails.vue?vue&type=script&lang=js&"
import style0 from "./PhonolEnvDetails.vue?vue&type=style&index=0&id=2aad518e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aad518e",
  null
  
)

export default component.exports